(function () {
  'use strict';

  const ROOT = '[data-rx-cd]';

  /*
   * Concept / Shopify product-grid selectors.
   * Pierwszy znaleziony element będzie celem scrollowania.
   */
  const PRODUCT_TARGETS = [
    '#ProductGridContainer',
    '[id*="ProductGridContainer"]',
    '#product-grid',
    '[data-product-grid]',
    '.product-grid',
    '.collection__products',
    '.collection-product-grid',
    '.collection__main'
  ];

  const FALLBACK_SCROLL_KEY =
    'rx-scroll-to-products';


  function all(selector, root) {
    return Array.from(
      (root || document).querySelectorAll(selector)
    );
  }


  /* ========================================================
     FIND PRODUCT GRID
     ======================================================== */

  function getProductTarget() {

    for (
      let i = 0;
      i < PRODUCT_TARGETS.length;
      i++
    ) {

      const target =
        document.querySelector(
          PRODUCT_TARGETS[i]
        );

      if (target) {
        return target;
      }

    }

    return null;
  }


  /* ========================================================
     SCROLL TO PRODUCTS
     ======================================================== */

  function scrollToProducts() {

    const target =
      getProductTarget();

    if (!target) {
      return false;
    }

    /*
     * Offset for Roxie sticky header / toolbar.
     */
    const offset =
      window.innerWidth <= 700
        ? 82
        : 105;

    const top =
      target.getBoundingClientRect().top
      +
      window.pageYOffset
      -
      offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });

    return true;
  }


  /* ========================================================
     NATIVE CONCEPT FILTER INPUT
     ======================================================== */

  function nativeFilterInput(name, value) {

    return all(
      'input[type="checkbox"],input[type="radio"]'
    ).find(function (input) {

      return (
        !input.closest(ROOT) &&
        input.name === name &&
        input.value === value
      );

    });

  }


  /* ========================================================
     CLOSE PANELS
     ======================================================== */

  function closePanels(root) {

    all(
      '[data-rx-filter-card]',
      root
    ).forEach(function (card) {

      card.classList.remove(
        'is-open'
      );

      card.setAttribute(
        'aria-expanded',
        'false'
      );

    });


    all(
      '[data-rx-panel]',
      root
    ).forEach(function (panel) {

      panel.classList.remove(
        'is-open'
      );

    });

  }


  /* ========================================================
     OPEN PANEL
     ======================================================== */

  function togglePanel(root, card) {

    const id =
      card.dataset.panel;

    const panel =
      document.getElementById(id);

    if (!panel) {
      return;
    }


    const alreadyOpen =
      card.classList.contains(
        'is-open'
      );


    closePanels(root);


    if (alreadyOpen) {
      return;
    }


    card.classList.add(
      'is-open'
    );

    card.setAttribute(
      'aria-expanded',
      'true'
    );

    panel.classList.add(
      'is-open'
    );


    /*
     * Only opening a filter panel scrolls
     * gently to the panel on mobile.
     */
    if (window.innerWidth <= 700) {

      window.setTimeout(function () {

        panel.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });

      }, 60);

    }

  }


  /* ========================================================
     SYNC ONE VALUE WITH NATIVE FILTER
     ======================================================== */

  function syncValue(button) {

    const input =
      nativeFilterInput(
        button.dataset.filterName,
        button.dataset.filterValue
      );


    if (!input) {
      return;
    }


    button.classList.toggle(
      'is-active',
      input.checked
    );


    button.classList.toggle(
      'is-disabled',
      !!input.disabled
    );


    button.setAttribute(
      'aria-pressed',
      input.checked
        ? 'true'
        : 'false'
    );

  }


  /* ========================================================
     SYNC CUSTOM UI
     ======================================================== */

  function syncRoot(root) {

    all(
      '[data-rx-filter-value]',
      root
    ).forEach(
      syncValue
    );


    all(
      '[data-rx-filter-card]',
      root
    ).forEach(function (card) {

      const panel =
        document.getElementById(
          card.dataset.panel
        );


      if (!panel) {
        return;
      }


      const count =
        all(
          '[data-rx-filter-value].is-active',
          panel
        ).length;


      card.classList.toggle(
        'is-selected',
        count > 0
      );


      const counter =
        card.querySelector(
          '[data-rx-filter-count]'
        );


      if (counter) {

        counter.textContent =
          count;

        counter.hidden =
          count === 0;

      }


      const status =
        card.querySelector(
          '[data-rx-filter-status]'
        );


      if (status) {

        status.textContent =
          count > 0
            ? count + ' selected'
            : card.dataset.options + ' options';

      }

    });


    const total =
      all(
        '[data-rx-filter-value].is-active',
        root
      ).length;


    const activeBar =
      root.querySelector(
        '[data-rx-active-bar]'
      );


    if (activeBar) {

      activeBar.classList.toggle(
        'has-active',
        total > 0
      );

    }


    const totalNode =
      root.querySelector(
        '[data-rx-active-total]'
      );


    if (totalNode) {

      totalNode.textContent =
        total;

    }

  }


  /* ========================================================
     WATCH CONCEPT AJAX UPDATE
     THEN SCROLL TO PRODUCTS

     Observer lives max ~1.8 seconds and disconnects.
     ======================================================== */

  function watchThemeUpdate(
    root,
    scrollAfter
  ) {

    let debounceTimer = null;
    let scrollDone = false;


    const observer =
      new MutationObserver(function () {

        window.clearTimeout(
          debounceTimer
        );


        debounceTimer =
          window.setTimeout(function () {

            syncRoot(root);


            if (
              scrollAfter &&
              !scrollDone
            ) {

              scrollDone =
                scrollToProducts();

            }

          }, 110);

      });


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );


    /*
     * Fallback in case Concept performs
     * an update that MutationObserver
     * doesn't catch in the expected way.
     */
    window.setTimeout(function () {

      syncRoot(root);


      if (
        scrollAfter &&
        !scrollDone
      ) {

        scrollDone =
          scrollToProducts();

      }

    }, 550);


    /*
     * Stop observer — important for performance.
     */
    window.setTimeout(function () {

      observer.disconnect();

      window.clearTimeout(
        debounceTimer
      );

    }, 1800);

  }


  /* ========================================================
     ACTIVATE FILTER
     ======================================================== */

  function activateFilter(root, button) {

    const input =
      nativeFilterInput(
        button.dataset.filterName,
        button.dataset.filterValue
      );


    /*
     * Best path:
     * use Concept's existing AJAX filtering.
     */
    if (input) {

      /*
       * Start listening BEFORE triggering
       * the native filter.
       */
      watchThemeUpdate(
        root,
        true
      );


      /*
       * Close our selector panel.
       * Customer now goes directly to products.
       */
      closePanels(root);


      input.click();

      return;
    }


    /*
     * Fallback if Concept markup changes.
     * Normal Shopify filter URL still works.
     */
    const fallback =
      button.dataset.fallback;


    if (fallback) {

      try {

        sessionStorage.setItem(
          FALLBACK_SCROLL_KEY,
          '1'
        );

      } catch (error) {}


      window.location.assign(
        fallback
      );

    }

  }


  /* ========================================================
     SEARCH WITHIN VALUES
     ======================================================== */

  function filterSearch(input) {

    const panel =
      input.closest(
        '[data-rx-panel]'
      );


    if (!panel) {
      return;
    }


    const query =
      input.value
        .trim()
        .toLowerCase();


    all(
      '[data-rx-filter-value]',
      panel
    ).forEach(function (item) {

      const text =
        item.dataset.search || '';


      item.style.display =
        text.includes(query)
          ? ''
          : 'none';

    });

  }


  /* ========================================================
     HORIZONTAL SLIDER
     ======================================================== */

  function scrollTrack(
    root,
    name,
    direction
  ) {

    const track =
      root.querySelector(
        '[data-rx-track="' +
        name +
        '"]'
      );


    if (!track) {
      return;
    }


    const card =
      track.querySelector(
        '.rx-cd-card'
      );


    const style =
      window.getComputedStyle(
        track
      );


    const gap =
      parseFloat(
        style.gap ||
        style.columnGap ||
        0
      );


    const distance =
      card
        ? card.getBoundingClientRect().width + gap
        : track.clientWidth * .75;


    track.scrollBy({
      left:
        direction *
        distance,

      behavior: 'smooth'
    });

  }


  /* ========================================================
     MOBILE EDGE HINT
     ======================================================== */

  function initTracks(root) {

    all(
      '[data-rx-track]',
      root
    ).forEach(function (track) {


      if (
        track.dataset.rxTrackReady === '1'
      ) {
        return;
      }


      track.dataset.rxTrackReady =
        '1';


      const viewport =
        track.closest(
          '.rx-cd__viewport'
        );


      if (!viewport) {
        return;
      }


      function update() {

        viewport.classList.toggle(
          'is-scrolled',
          track.scrollLeft > 10
        );

      }


      track.addEventListener(
        'scroll',
        update,
        {
          passive: true
        }
      );


      update();

    });

  }


  /* ========================================================
     CLEAR FILTERS
     ======================================================== */

  function clearFilters(root) {

    const clearUrl =
      root.dataset.clearUrl;


    if (!clearUrl) {
      return;
    }


    /*
     * Prefer native Concept "clear all",
     * if available.
     */
    const nativeClear =
      document.querySelector(
        [
          '.active-facets__button-remove',
          '[data-clear-filters]',
          '.facets__reset'
        ].join(',')
      );


    if (
      nativeClear &&
      !nativeClear.closest(ROOT)
    ) {

      watchThemeUpdate(
        root,
        true
      );

      nativeClear.click();

      return;
    }


    /*
     * Safe navigation fallback.
     */
    try {

      sessionStorage.setItem(
        FALLBACK_SCROLL_KEY,
        '1'
      );

    } catch (error) {}


    window.location.assign(
      clearUrl
    );

  }


  /* ========================================================
     INIT
     ======================================================== */

  function initRoot(root) {

    if (
      !root ||
      root.dataset.rxReady === '1'
    ) {
      return;
    }


    root.dataset.rxReady =
      '1';


    initTracks(root);

    syncRoot(root);


    /*
     * One delegated click listener.
     */
    root.addEventListener(
      'click',
      function (event) {


        const next =
          event.target.closest(
            '[data-rx-next]'
          );


        if (next) {

          scrollTrack(
            root,
            next.dataset.rxNext,
            1
          );

          return;
        }


        const prev =
          event.target.closest(
            '[data-rx-prev]'
          );


        if (prev) {

          scrollTrack(
            root,
            prev.dataset.rxPrev,
            -1
          );

          return;
        }


        const card =
          event.target.closest(
            '[data-rx-filter-card]'
          );


        if (card) {

          togglePanel(
            root,
            card
          );

          return;
        }


        const close =
          event.target.closest(
            '[data-rx-close]'
          );


        if (close) {

          closePanels(root);

          return;
        }


        const value =
          event.target.closest(
            '[data-rx-filter-value]'
          );


        if (value) {

          activateFilter(
            root,
            value
          );

          return;
        }


        const clear =
          event.target.closest(
            '[data-rx-clear]'
          );


        if (clear) {

          clearFilters(root);

        }

      }
    );


    /*
     * Search values.
     */
    root.addEventListener(
      'input',
      function (event) {

        if (
          event.target.matches(
            '[data-rx-search]'
          )
        ) {

          filterSearch(
            event.target
          );

        }

      }
    );


    /*
     * If normal page navigation was required,
     * continue at products after reload.
     */
    try {

      if (
        sessionStorage.getItem(
          FALLBACK_SCROLL_KEY
        ) === '1'
      ) {

        sessionStorage.removeItem(
          FALLBACK_SCROLL_KEY
        );


        window.setTimeout(function () {

          scrollToProducts();

        }, 250);

      }

    } catch (error) {}

  }


  /* ========================================================
     INIT ALL
     ======================================================== */

  function initAll() {

    all(ROOT).forEach(
      initRoot
    );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll,
      {
        once: true
      }
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    initAll
  );

})();